import { Product, Category, PageSEO, SitePagesContent, OrderInquiry, NewsTickerSettings, StoriesSettings, SectionLayoutItem } from '../types';
import defaultProducts from './defaultProducts.json';

export const INITIAL_CATEGORIES: Category[] = [
  {
    id: 'phone-cases',
    name: 'Phone Cases',
    slug: 'phone-cases',
    tagline: 'Print Your Photo or Art on Phone Cases',
    description: 'Customize your favorite memories, artwork, pet portraits, or designs on custom cases for almost all phone brands in Lebanon.',
    heroImage: '/images/phone-cases/img_01.webp',
    badge: 'POPULAR',
    iconName: 'Smartphone',
    active: true,
  },
  {
    id: 'canvas',
    name: 'Wall Art Canvas',
    slug: 'canvas',
    tagline: 'Personal Photos & Art on Canvas',
    description: 'Turn your wedding photos, family portraits, travel memories, and digital art into premium canvas wall art in Lebanon.',
    heroImage: '/images/canvas/img_02.webp',
    badge: 'POPULAR',
    iconName: 'Palette',
    active: true,
  },
  {
    id: 'photo-frames',
    name: 'Photo Frames',
    slug: 'photo-frames',
    tagline: 'Custom Framed Wall & Desk Photos',
    description: 'Turn your family portraits, wedding memories, graduation moments, and artwork into timeless framed prints with protective crystal acrylic glass.',
    heroImage: '/images/photo-frames/img_03.webp',
    badge: 'NEW',
    iconName: 'Frame',
    active: true,
  },
  {
    id: 'wood-crafts',
    name: 'Wood Crafts',
    slug: 'wood-crafts',
    tagline: 'Laser Engraved & Handcrafted Solid Wood Decor',
    description: 'Custom personalized solid wood signs, engraved desk plaques, rustic memory blocks, and artisan handcrafted decor tailored in Lebanon.',
    heroImage: '/images/wood-crafts/img_13.webp',
    badge: 'HANDCRAFTED',
    iconName: 'Hammer',
    active: true,
  },
  {
    id: 'keychains',
    name: 'Custom Keychains',
    slug: 'keychains',
    tagline: 'Personalized Acrylic, Metal & Leather Photo Keychains',
    description: 'Carry your favorite memories, Spotify song codes, custom typography, and couple portraits everywhere with durable double-sided custom keychains.',
    heroImage: '/images/keychains/img_14.webp',
    badge: 'TRENDING',
    iconName: 'Key',
    active: true,
  },
  {
    id: 'mugs',
    name: 'Drinking Mugs',
    slug: 'mugs',
    tagline: 'Custom Photo & Quote Ceramic Mugs',
    description: '11oz and 15oz dishwasher-safe ceramic mugs customized with your photos, funny quotes, custom names, or company logos.',
    heroImage: '/images/mugs/img_04.webp',
    badge: 'PERFECT GIFT',
    iconName: 'Coffee',
    active: true,
  },
  {
    id: 'tshirts',
    name: 'Custom T-Shirts',
    slug: 'tshirts',
    tagline: 'Print Your Image on 100% Premium Cotton',
    description: 'High-definition digital printing on premium combed cotton t-shirts. Print your photos, artwork, custom typography, or brand logos.',
    heroImage: '/images/tshirts/img_05.webp',
    badge: 'BEST VALUE',
    iconName: 'Shirt',
    active: true,
  },
  {
    id: 'hoodies',
    name: 'Custom Hoodies',
    slug: 'hoodies',
    tagline: 'Cozy Fleece with Custom Chest & Back Print',
    description: 'Premium heavyweight cotton fleece hoodies customized with your large back graphic, photo, logo, or personalized text.',
    heroImage: '/images/hoodies/img_06.webp',
    badge: 'WARM & COZY',
    iconName: 'Shirt',
    active: true,
  },
  {
    id: 'stickers',
    name: 'Custom Stickers',
    slug: 'stickers',
    tagline: 'Waterproof Die-Cut Vinyl Stickers',
    description: 'Durable, UV-laminated die-cut vinyl stickers customized from your photos, digital art, or business branding.',
    heroImage: '/images/stickers/img_07.webp',
    badge: 'PACKS',
    iconName: 'Sparkles',
    active: true,
  },
  {
    id: 'hats',
    name: 'Hats & Caps',
    slug: 'hats',
    tagline: 'Personalized Headwear with Custom Text/Logo',
    description: 'Structured snapbacks and dad caps customized with your personalized initials, custom slogan, or embroidered/printed logo.',
    heroImage: '/images/hats/img_08.webp',
    badge: 'CUSTOM',
    iconName: 'HardHat',
    active: true,
  },
];

export const INITIAL_PRODUCTS: Product[] = [];

export const DEFAULT_NEWS_TICKER: NewsTickerSettings = {
  enabled: false,
  speed: 25,
  backgroundColor: '#111111',
  textColor: '#FFFFFF',
  badgeBackgroundColor: '#E21B24',
  badgeTextColor: '#FFFFFF',
  borderColor: '#262626',
  pauseOnHover: true,
  showIcon: true,
  showBadge: true,
  label: 'FLASH NEWS',
  items: [
    {
      id: 'news-1',
      text: 'Free delivery this Sunday on all custom orders across Lebanon!',
      badge: 'FREE DELIVERY',
      icon: 'truck',
      link: 'shop',
      active: true,
    },
    {
      id: 'news-2',
      text: '10% OFF on all products — Use promo code COVERISTIC10 on WhatsApp!',
      badge: '10% OFF',
      icon: 'tag',
      link: 'shop',
      active: true,
    },
    {
      id: 'news-3',
      text: 'Fast 24-48hr express courier delivery with Cash on Delivery nationwide',
      badge: 'EXPRESS DISPATCH',
      icon: 'zap',
      link: 'about',
      active: true,
    },
    {
      id: 'news-4',
      text: 'Image preview before printing request is available before printing (+961 81 773 349)',
      badge: 'PREVIEW AVAILABLE',
      icon: 'sparkles',
      link: 'custom-print',
      active: true,
    },
  ]
};

export const DEFAULT_STORIES: StoriesSettings = {
  enabled: true,
  viewDuration: 5,
  label: 'COVERISTIC STORIES & DROPS',
  items: [
    {
      id: 'story-cases',
      title: 'Phone Cases',
      subtitle: 'Custom UV Prints for All Devices',
      image: '/images/phone-cases/img_01.webp',
      images: [
        '/images/phone-cases/img_01.webp',
        '/images/phone-cases/img_02.webp'
      ],
      badge: 'TOP SELLER',
      ctaText: 'Browse Phone Cases',
      ctaCategory: 'phone-cases',
      buttonEnabled: true
    },
    {
      id: 'story-canvas',
      title: 'Canvas Art',
      subtitle: 'Museum Grade Stretched Wall Decor',
      image: '/images/canvas/img_02.webp',
      images: [
        '/images/canvas/img_02.webp',
        '/images/canvas/img_01.webp'
      ],
      badge: 'MUSEUM GRADE',
      ctaText: 'Explore Canvas Art',
      ctaCategory: 'canvas',
      buttonEnabled: true
    },
    {
      id: 'story-frames',
      title: 'Photo Frames',
      subtitle: 'A4 & A3 Crystal Acrylic Prints',
      image: '/images/photo-frames/img_03.webp',
      images: [
        '/images/photo-frames/img_03.webp',
        '/images/photo-frames/img_02.webp'
      ],
      badge: 'NEW ARRIVAL',
      ctaText: 'View Photo Frames',
      ctaCategory: 'photo-frames',
      buttonEnabled: true
    },
    {
      id: 'story-tees',
      title: 'Graphic Tees',
      subtitle: '100% Combed Heavy Cotton Streetwear',
      image: '/images/tshirts/img_05.webp',
      images: [
        '/images/tshirts/img_05.webp',
        '/images/tshirts/img_01.webp'
      ],
      badge: 'PREMIUM COTTON',
      ctaText: 'Shop T-Shirts',
      ctaCategory: 'tshirts',
      buttonEnabled: true
    }
  ]
};

export const DEFAULT_SECTION_ORDER: SectionLayoutItem[] = [
  { id: 'hero', label: 'Hero Banner', enabled: true },
  { id: 'stories', label: 'Coveristic Stories Tray', enabled: true },
  { id: 'newsTicker', label: 'News Ticker / Flash Deals', enabled: true },
  { id: 'showcase', label: 'Product Catalog Showcase', enabled: true },
  { id: 'customPrint', label: 'Custom Print On Demand Spotlight', enabled: true },
  { id: 'features', label: 'Trust & Nationwide Delivery Badges', enabled: true }
];

export const INITIAL_PAGES_CONTENT: SitePagesContent = {
  announcementBar: {
    enabled: true,
    text: '⚡ CUSTOM PRINT ON DEMAND LEBANON • PRINT YOUR OWN PHOTOS & DESIGNS • IMAGE PREVIEW BEFORE PRINTING AVAILABLE • CASH ON DELIVERY',
    secondaryText: 'WHATSAPP ORDER: +961 81 773 349',
    whatsappNumber: '+96181773349',
  },
  newsTicker: DEFAULT_NEWS_TICKER,
  storiesSettings: DEFAULT_STORIES,
  sectionOrder: DEFAULT_SECTION_ORDER,
  headerConfig: {
    announcementText: '⚡ CUSTOM PRINT ON DEMAND LEBANON • PRINT YOUR OWN PHOTOS & DESIGNS',
    secondaryAnnouncement: 'WHATSAPP ORDER: +961 81 773 349',
    whatsappNumber: '+96181773349',
    brandTagline: 'Custom Print on Demand Studio',
    showSearch: true,
    showLanguageSwitch: true
  },
  footerConfig: {
    brandDescription: 'Coveristic is Lebanon\'s dedicated custom print-on-demand studio. We specialize in high-quality personalized prints on custom Phone Cases for all brands, Wall Art Canvas, Ceramic Drinking Mugs, T-Shirts, Hoodies, and Die-Cut Stickers.',
    location: 'Beirut & All Regions Across Lebanon',
    hours: 'Monday - Saturday: 9:00 AM - 8:00 PM',
    whatsappNumber: '+96181773349',
    instagramUrl: 'https://instagram.com/coveristic.lb',
    facebookUrl: 'https://facebook.com/coveristic',
    tiktokUrl: 'https://tiktok.com/@coveristic',
    copyrightText: '© Coveristic. All rights reserved. Express courier delivery across Lebanon.'
  },
  mainContentConfig: {
    showcaseTitle: 'CUSTOM PRINT ON DEMAND CATALOG',
    showcaseSubtitle: 'Choose from our curated designs or request your custom photos printed on any item',
    defaultCategory: 'all',
    productsPerPage: 24
  },
  tagDisplaySettings: {
    size: 'md',
    showDot: true,
  },
  hero: {
    eyebrow: '★ CUSTOM PRINT ON DEMAND STUDIO • LEBANON',
    headline: 'PRINT YOUR PHOTOS & CUSTOM ART ON CASES, CANVAS, MUGS & HOODIES',
    subheadline: 'Customize your favorite memories, artwork, pet portraits, and logos on custom Phone Cases, Wall Art Canvas, Drinking Mugs, T-Shirts, Hoodies & Stickers. Send your image to WhatsApp (+961 81773349) — image preview before printing request is available before printing!',
    ctaPrimary: 'Browse Custom Products',
    ctaSecondary: 'Send Your Photo on WhatsApp',
    bannerImage: '/images/catalog/img_18.webp',
  },
  aboutStory: {
    title: 'Your Personal Print on Demand Studio in Lebanon',
    tagline: 'Customized Prints on Phone Cases, Wall Art, Mugs, Apparel & Stickers',
    storyParagraphs: [
      'Coveristic is an independent customized print-on-demand studio in Lebanon. We specialize in taking your personal photos, artwork, wedding memories, pet portraits, digital illustrations, or brand logos, and printing them with precision onto high-quality products.',
      'Our product lineup includes Phone Cases (for all phone brands), Canvas Wall Art, Photo Frames (A4 & A3 sizes), ceramic Drinking Mugs, T-Shirts, Hoodies, Wood Crafts and Die-Cut Stickers.',
      'We made ordering effortless: browse our customizable items, pick your device model or dimensions, and forward your order directly to our official WhatsApp (+961 81773349). You can attach your photo or design directly in the WhatsApp chat. An image preview before printing request is available before printing, and we print and dispatch with Cash on Delivery or Whish Money across all regions of Lebanon including Beirut, Mount Lebanon, South Lebanon, North Lebanon, and Bekaa.'
    ],
    locationNotice: 'Express Courier Delivery across all Lebanon: Beirut, Mount Lebanon, South Lebanon (Saida & Tyre), North Lebanon (Tripoli & Byblos), Bekaa & everywhere nationwide.',
    whatsappDirect: '+96181773349',
  },
  customPrintService: {
    title: 'Custom Print on Demand Service',
    subtitle: 'Print Any Photo, Artwork, or Logo on Our Products',
    steps: [
      {
        title: '1. Select Your Product',
        desc: 'Choose from custom Phone Cases, Wall Art Canvas, Photo Frames (A4 & A3), Ceramic Mugs, T-Shirts, Hoodies, or Stickers.'
      },
      {
        title: '2. Send Your Photo on WhatsApp',
        desc: 'Send your picture, photo, or design directly to our WhatsApp (+961 81773349). We accept JPG, PNG, PSD, or PDF.'
      },
      {
        title: '3. Image Preview Before Printing',
        desc: 'Image preview before printing request is available before printing so you can see exactly how your customized image looks on the product.'
      },
      {
        title: '4. Print & Express Courier Delivery',
        desc: 'Once approved, we print with durable UV/DTF inks and dispatch across Lebanon with Cash on Delivery.'
      }
    ]
  },
  faq: [
    {
      question: 'How do I print my own custom photo or image?',
      answer: 'It is very simple! Pick the product you want (Phone Case, Canvas, Mug, T-Shirt, Hoodie, or Sticker), select your device model or size, and click "Order via WhatsApp". This opens a chat with us at +961 81773349 where you can directly attach your photo or design file. Image preview before printing request is available before printing!',
      category: 'Customization'
    },
    {
      question: 'Do I pay online with a credit card?',
      answer: 'No! You never make a payment inside the website. All orders are finalized directly through WhatsApp. You pay upon receiving your package via Cash on Delivery (COD in USD) or via Whish Money / OMT.',
      category: 'Payment'
    },
    {
      question: 'Which phone case models can I customize?',
      answer: 'We custom print for all available phone brands in Lebanon:\n\n• Apple (iPhone 11, 12, 13, 14, 15, and 16 series — Standard, Plus, Pro, and Pro Max)\n• Samsung Galaxy (S-Series: S21, S22, S23, S24, S25 Ultra / Plus / Base; A-Series; Z Fold & Z Flip)\n• Xiaomi, Redmi & POCO (Xiaomi 13/14, Redmi Note series, POCO X/F series)\n• Huawei & Honor (P-Series, Mate Series, Honor Magic & X series)\n• Google Pixel (Pixel 6, 7, 8, and 9 series / Pro)\n• Tecno & Infinix (Camon, Spark, Hot, Note series)\n• OnePlus & Motorola\n\nNo matter your device, message us on WhatsApp (+961 81773349) with your exact model and an image preview before printing request is available before printing.',
      category: 'Phone Cases'
    },
    {
      question: 'Can you do custom design for me?',
      answer: 'Yes! We do custom graphic design with anything you desire. Whether you want personalized text, custom typography, background removal, photo collages, couple & pet portraits, artistic filters, or brand logos, our team will create the design for you and an image preview before printing request is available before printing for your approval.',
      category: 'Design Service'
    },
    {
      question: 'What quality should my photo be?',
      answer: 'Any clear photo taken with a modern smartphone (iPhone, Samsung) will look fantastic on our cases, canvas, and mugs! If you have a professional photography file (from a wedding or camera), we support full-resolution uncompressed files on WhatsApp.',
      category: 'Print Quality'
    },
    {
      question: 'How fast is delivery across Lebanon?',
      answer: 'We print within 24 to 48 hours. Express courier delivery arrives within 24 to 48 hours after printing across all Lebanese areas and cities: Beirut (all districts), Mount Lebanon (Metn, Keserwan, Baabda, Chouf, Aley), South Lebanon (Saida, Tyre, Nabatieh, Jezzine), North Lebanon (Tripoli, Byblos, Batroun, Koura, Akkar), and Bekaa (Zahle, Baalbek, West Bekaa) — delivering everywhere in Lebanon with Cash on Delivery.',
      category: 'Delivery'
    }
  ],
  contactInfo: {
    whatsappNumber: '+96181773349',
    whatsappDisplay: '+961 81 773 349',
    location: 'Lebanon',
    hours: 'Monday - Saturday: 10:00 AM - 9:00 PM (WhatsApp available 24/7)',
    deliveryTime: '24 - 48 Hours Express Delivery Across Lebanon',
    paymentMethods: 'Cash on Delivery (USD) • Whish Money • OMT',
  },
  offersPageSettings: {
    seasonName: 'Seasonal Special Deals',
    headline: 'Seasonal Offers & Bundle Deals',
    subheadline: 'Special discounts, promotional prices, and exclusive bundle deals updated every season for all our custom print products in Lebanon.',
    bundleDealsNotice: 'Order 2 or more items or create a personalized bundle directly with our studio designers on WhatsApp.'
  }
};

export const INITIAL_PAGES_SEO: PageSEO[] = [
  {
    id: 'home',
    name: 'Home Page',
    path: '/',
    title: 'Coveristic – Custom Prints on Phone Cases, Canvas, Mugs, Apparel & Stickers',
    description: 'Customize your photos and designs on Phone Cases, Wall Art Canvas, Drinking Mugs, T-Shirts, Hoodies & Stickers in Lebanon. Order directly on WhatsApp: +961 81773349.',
    keywords: 'Coveristic, custom phone cases Lebanon, print your image phone case, custom canvas Lebanon, custom mugs Lebanon, customized hoodies Lebanon, print on demand Lebanon, photo gift Lebanon, WhatsApp order Lebanon',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Store',
      name: 'Coveristic',
      telephone: '+96181773349',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'LB'
      }
    }
  },
  {
    id: 'phone-cases',
    name: 'Phone Cases Collection',
    path: '/category/phone-cases',
    title: 'Custom Photo & Art Phone Cases (All Phone Brands) | Coveristic Lebanon',
    description: 'Print your personal photos, artwork, or pet portraits on custom phone cases for all phone models in Lebanon. Image preview before printing request is available before printing via WhatsApp +961 81773349.',
    keywords: 'custom phone cases Lebanon, print photo phone case, personalized phone case Lebanon',
    ogImage: '/images/catalog/img_19.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/phone-cases',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Phone Cases by Coveristic'
    }
  },
  {
    id: 'photo-frames',
    name: 'Photo Frames Collection',
    path: '/category/photo-frames',
    title: 'Custom Photo Frames & Gallery Wall Prints | Coveristic Lebanon',
    description: 'Transform your cherished wedding memories, family portraits, and graduation photography into solid wooden framed prints in Lebanon. WhatsApp order +961 81773349.',
    keywords: 'custom photo frames Lebanon, picture frames Lebanon, framed photo prints Lebanon, wedding frames Lebanon, gallery wall photo frames Beirut',
    ogImage: '/images/catalog/img_20.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/photo-frames',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Photo Frames by Coveristic'
    }
  },
  {
    id: 'wood-crafts',
    name: 'Wood Crafts Collection',
    path: '/category/wood-crafts',
    title: 'Custom Laser Engraved Solid Wood Crafts & Decor | Coveristic Lebanon',
    description: 'Personalized solid pine wood desk plaques, engraved rustic wall signs, and custom wooden decor in Lebanon. WhatsApp order +961 81773349.',
    keywords: 'custom wood crafts Lebanon, laser engraved wood Lebanon, personalized wood plaque Lebanon, wooden signs Beirut',
    ogImage: '/images/catalog/img_13.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/wood-crafts',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Wood Crafts by Coveristic'
    }
  },
  {
    id: 'keychains',
    name: 'Custom Keychains Collection',
    path: '/category/keychains',
    title: 'Custom Acrylic & Engraved Metal Keychains | Coveristic Lebanon',
    description: 'Double-sided custom photo acrylic keychains, Spotify song codes, and laser-engraved metal leather keychains in Lebanon. WhatsApp +961 81773349.',
    keywords: 'custom keychains Lebanon, photo keychain Lebanon, acrylic spotify keychain Lebanon, personalized keychain Beirut',
    ogImage: '/images/catalog/img_14.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/keychains',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Keychains by Coveristic'
    }
  },
  {
    id: 'stickers',
    name: 'Custom Stickers Collection',
    path: '/category/stickers',
    title: 'Custom Die-Cut Waterproof Vinyl Stickers | Coveristic Lebanon',
    description: 'Durable UV-laminated die-cut vinyl stickers customized from your photos, digital art, or business logos in Lebanon. WhatsApp +961 81773349.',
    keywords: 'custom stickers Lebanon, vinyl stickers Lebanon, die cut stickers Beirut',
    ogImage: '/images/catalog/img_07.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/stickers',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Vinyl Stickers by Coveristic'
    }
  },
  {
    id: 'hats',
    name: 'Custom Hats & Caps Collection',
    path: '/category/hats',
    title: 'Custom Embroidered & Printed Cotton Caps | Coveristic Lebanon',
    description: 'Personalized unstructured cotton snapback caps customized with your initials, names, or custom logo in Lebanon. WhatsApp +961 81773349.',
    keywords: 'custom hats Lebanon, personalized caps Lebanon, custom embroidered caps Beirut',
    ogImage: '/images/catalog/img_08.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/hats',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Hats by Coveristic'
    }
  },
  {
    id: 'canvas',
    name: 'Wall Art Canvas Collection',
    path: '/category/canvas',
    title: 'Custom Photo Canvas Wall Art | Coveristic Lebanon',
    description: 'Turn your wedding photos, family memories, and digital art into premium canvas wall art in Lebanon. WhatsApp order +961 81773349.',
    keywords: 'custom canvas Lebanon, photo canvas Lebanon, wedding canvas Lebanon, canvas art Lebanon',
    ogImage: '/images/catalog/img_20.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/canvas',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Wall Art Canvas by Coveristic'
    }
  },
  {
    id: 'mugs',
    name: 'Mugs Collection',
    path: '/category/mugs',
    title: 'Custom Photo & Quote Mugs | Coveristic',
    description: 'Personalized ceramic coffee mugs printed with your photos, quotes, or business logos in Lebanon. WhatsApp order +961 81773349.',
    keywords: 'custom mugs Lebanon, photo mug Lebanon, personalized coffee mug Lebanon',
    ogImage: '/images/catalog/img_21.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/mugs',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Drinking Mugs by Coveristic'
    }
  },
  {
    id: 'tshirts',
    name: 'Custom T-Shirts Collection',
    path: '/category/tshirts',
    title: 'Custom Printed T-Shirts (100% Cotton) | Coveristic Lebanon',
    description: 'Print your photos, graphics, or logos on premium combed cotton t-shirts in Lebanon. Quick WhatsApp ordering +961 81773349.',
    keywords: 'custom tshirts Lebanon, print photo on tshirt Lebanon, custom graphic tees Lebanon',
    ogImage: '/images/catalog/img_22.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/tshirts',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom T-Shirts by Coveristic'
    }
  },
  {
    id: 'hoodies',
    name: 'Custom Hoodies Collection',
    path: '/category/hoodies',
    title: 'Custom Printed Fleeced Hoodies | Coveristic Lebanon',
    description: 'Heavyweight cozy fleece hoodies customized with your large back graphic, photo, or brand logo in Lebanon. Order via WhatsApp +961 81773349.',
    keywords: 'custom hoodies Lebanon, print photo hoodie Lebanon, personalized hoodies Lebanon',
    ogImage: '/images/catalog/img_23.webp',
    ogType: 'product.group',
    canonicalUrl: 'https://coveristic.net/category/hoodies',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Custom Hoodies by Coveristic'
    }
  },
  {
    id: 'shop',
    name: 'Full Product Catalog (/shop)',
    path: '/shop',
    title: 'Shop Custom Prints & Personalized Gifts | Coveristic Lebanon',
    description: 'Browse our full catalog of custom phone cases, stretched canvas art, photo frames, wood crafts, mugs, t-shirts, hoodies, and stickers with Cash on Delivery across Lebanon.',
    keywords: 'shop Coveristic, custom print catalog Lebanon, personalized gifts Beirut, custom phone cases shop',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/shop',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Coveristic Custom Print Catalog'
    }
  },
  {
    id: 'custom-print',
    name: 'Custom Print on Demand Studio',
    path: '/custom-print',
    title: 'Custom Print on Demand Service – Print Your Photos | Coveristic Lebanon',
    description: 'Send any photo, artwork, or brand logo on WhatsApp (+961 81773349) to custom print on phone cases, canvas, frames, mugs, and apparel in Lebanon.',
    keywords: 'custom print on demand Lebanon, print your own photo Lebanon, custom design studio Beirut',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/custom-print',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Coveristic Custom Print on Demand Service'
    }
  },
  {
    id: 'blog',
    name: 'Blog & City Printing Guides',
    path: '/blog',
    title: 'Custom Printing Blog & Lebanon City Guides | Coveristic',
    description: 'Read guides, gift ideas, and custom printing spotlights across Beirut, Saida, Tripoli, Byblos, Tyre, Zahle, and all Lebanese regions.',
    keywords: 'Coveristic blog, custom printing blog Lebanon, gift guide Lebanon, print on demand articles',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/blog',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Coveristic Print Studio Blog'
    }
  },
  {
    id: 'about',
    name: 'About Coveristic & Custom Studio',
    path: '/about',
    title: 'About Coveristic – Custom Print on Demand Studio in Lebanon',
    description: 'Learn how Coveristic prints your custom images on Phone Cases, Wall Canvas, Mugs, Apparel, and Stickers in Lebanon. Contact on WhatsApp +961 81773349.',
    keywords: 'about Coveristic, custom print Lebanon, print on demand studio Lebanon',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/about',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'About Coveristic'
    }
  },
  {
    id: 'contact',
    name: 'Contact Us Page (/contact)',
    path: '/contact',
    title: 'Contact Us – Custom Print Studio & Support | Coveristic Lebanon',
    description: 'Contact Coveristic Print Studio in Lebanon via our direct online contact form or WhatsApp (+961 81 773 349) for custom phone cases, canvas art, mugs, apparel, and corporate merchandise.',
    keywords: 'contact Coveristic, custom print support Lebanon, Coveristic WhatsApp Lebanon, custom printing inquiry Beirut',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/contact',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact Coveristic Print Studio Lebanon'
    }
  },
  {
    id: 'offers',
    name: 'Seasonal Offers & Bundle Deals',
    path: '/offers',
    title: 'Seasonal Offers & Bundle Deals | Coveristic Lebanon',
    description: 'Explore limited-time seasonal discounts and special bundle deals on custom phone cases, canvas wall art, photo frames, and apparel across Lebanon.',
    keywords: 'Coveristic offers, seasonal deals Lebanon, phone case bundle Lebanon, canvas discount Lebanon, custom print promotions Beirut',
    ogImage: '/hero%20image%20coveristic.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/offers',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Seasonal Offers & Bundle Deals by Coveristic'
    }
  },
  {
    id: 'rss',
    name: 'RSS Syndication Feed (/rss)',
    path: '/rss',
    title: 'RSS Feed – Products per Category & Blog Posts | Coveristic Lebanon',
    description: 'Subscribe to the official Coveristic RSS 2.0 syndication feed featuring all custom print products organized by category and latest blog articles.',
    keywords: 'Coveristic RSS feed, product feed Lebanon, custom print syndication XML',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/rss',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Coveristic RSS Feed'
    }
  },
  {
    id: 'sitemap',
    name: 'XML Sitemap Directory (/sitemap)',
    path: '/sitemap',
    title: 'Sitemap & Store Directory | Coveristic Lebanon',
    description: 'Complete XML and HTML sitemap directory of all Coveristic custom print categories, products, and blog articles in Lebanon.',
    keywords: 'Coveristic sitemap, store directory Lebanon',
    ogImage: '/images/catalog/img_18.webp',
    ogType: 'website',
    canonicalUrl: 'https://coveristic.net/sitemap',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Coveristic Sitemap'
    }
  }
];

export const INITIAL_SAMPLE_ORDERS: OrderInquiry[] = [];
